// Role Base Route Access
import React from "react";
import { Navigate } from "react-router-dom";
import useUserStore from "../stores/store";

const RouteGuard = ({ children, allowedRoles }) => {
  let { isLoggedIn, role } = useUserStore();

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(role)) {
    return <Navigate to="/unauthorized" replace />;
  }
  
  return children;
};

export default RouteGuard;
